'use client';

import { useScroll } from 'ahooks';
import { Fragment, useEffect } from 'react';
import { cn } from '@/app/utils';
import { Link } from '@/i18n/routing';

interface BreadcrumbsProps {
  pathname: {
    label: string;
    href: string;
  }[];
  className?: string;
}

export default function Breadcrumbs({ pathname, className }: BreadcrumbsProps) {
  const offset = useScroll(typeof window !== 'undefined' ? document : null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const header = document.querySelector('header');
    if (header) {
      header.style.backgroundColor = (offset?.top ?? 0) > 0 ? 'rgba(0, 0, 0)' : 'transparent';
    }
  }, [offset]);

  return (
    <nav
      className={cn(
        'hide-scrollbar flex h-20 w-full items-center overflow-x-scroll font-medium text-xl sm:h-[50px] sm:text-sm',
        (offset?.top ?? 0) > 0 && 'bg-black backdrop-blur-sm',
        className,
      )}
    >
      {pathname.map((item, index) => (
        <Fragment key={item.href}>
          {index === pathname.length - 1 ? (
            <span className="whitespace-nowrap text-white/60">{item.label}</span>
          ) : (
            <>
              <Link href={item.href} prefetch={false} className="whitespace-nowrap text-white">
                {item.label}
              </Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="mx-3 flex-shrink-0 sm:mx-1 sm:h-4 sm:w-4"
              >
                <path
                  d="M9 5L15 12L9 19"
                  stroke="white"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
